import { Edit3 } from 'lucide-react';
import { DashboardTableRowActionItem, DashboardTableRowActions } from '@shigo-ui/dashboard-ui';

import { dashboardT } from '../../../../../lib/messages';
import type { Brand } from '../../model';

type BrandActionsProps = {
  brand: Brand;
  onEdit: (brand: Brand) => void;
};

export function BrandActions({ brand, onEdit }: BrandActionsProps) {
  return (
    <DashboardTableRowActions label={dashboardT('brands.actions')}>
      <DashboardTableRowActionItem
        onClick={() => {
          onEdit(brand);
        }}
      >
        <Edit3 aria-hidden="true" />
        {dashboardT('brands.action.edit')}
      </DashboardTableRowActionItem>
    </DashboardTableRowActions>
  );
}
